import { InjectionToken } from '@angular/core';
import { GAClientConfig } from '../interfaces';

export const GA_CLIENT = new InjectionToken<GAClientConfig>(
  'Google Tags Client Token'
);
